import axios from "axios";

const axiosInstance = axios.create({
  // stage
  baseURL: process.env.REACT_APP_BASEURL_STAGE,
});

const loginInstance = axios.create({
  baseURL: process.env.REACT_APP_OAUTH_BASE_URL_STAGE,
});

axiosInstance.interceptors.request.use(function (config) {
  // config.headers["authorization"] = token ? `${token}` : "";
  config.headers["platform"] = 1;
  config.headers["app-version"] = 1.0;
  config.headers["platform-version"] = 10.3;
  config.headers["Content-Type"] = "application/json";
  return config;
});

export { axiosInstance, loginInstance };
